<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 200px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <v-autocomplete
        v-model="value"
        v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        :disabled="readonly"
        :items="options(fieldType.options)"
        :aria-label="fieldType.text || question.text"
        browser-autocomplete="off"
        item-text="text"
        item-value="id"
        dense
        auto-select-first
        @input="save"
      >
        <v-icon
          v-if="answer.status"
          slot="prepend"
        >
          {{ statusIconClass }}
        </v-icon>
      </v-autocomplete>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'DropdownAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      value: null,
      savedValue: null,
      failed: false,
      menu: false
    }
  },
  beforeMount () {
    this.value = this.answer.option || null
  },
  methods: {
    options (items) {
      return [{text: '', value: null}].concat(items)
    }
  }
}
</script>

<style>
.follow-up select {
  background-color: #ffffcc;
}
</style>
